/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BasePromoBannerItemFragment, PromoBannerItemFragment, FullPromoBannerItemFragment} from '@amblique/contentful/app/contentful/fragments/promo-banner-item';

/**
 * Get a single PromoBannerItem by ID (base - scalars only)
 */
export const getBasePromoBannerItemById = gql`
  ${BasePromoBannerItemFragment}

  query GetBasePromoBannerItemById($id: String!, $locale: String!, $preview: Boolean) {
    promoBannerItem(id: $id, locale: $locale, preview: $preview) {
      ...BasePromoBannerItemFragment
    }
  }
`;

/**
 * Get a single PromoBannerItem by ID (standard - 1 level deep)
 */
export const getPromoBannerItemById = gql`
  ${PromoBannerItemFragment}

  query GetPromoBannerItemById($id: String!, $locale: String!, $preview: Boolean) {
    promoBannerItem(id: $id, locale: $locale, preview: $preview) {
      ...PromoBannerItemFragment
    }
  }
`;

/**
 * Get a single PromoBannerItem by ID (full - 2 levels deep)
 */
export const getFullPromoBannerItemById = gql`
  ${FullPromoBannerItemFragment}

  query GetFullPromoBannerItemById($id: String!, $locale: String!, $preview: Boolean) {
    promoBannerItem(id: $id, locale: $locale, preview: $preview) {
      ...FullPromoBannerItemFragment
    }
  }
`;

/**
 * Get all PromoBannerItem entries with pagination (base - scalars only)
 */
export const getBasePromoBannerItems = gql`
  ${BasePromoBannerItemFragment}

  query GetBasePromoBannerItems(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PromoBannerItemOrder]
    $where: PromoBannerItemFilter
    $preview: Boolean
  ) {
    promoBannerItemCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BasePromoBannerItemFragment
      }
    }
  }
`;

/**
 * Get all PromoBannerItem entries with pagination (standard - 1 level deep)
 */
export const getPromoBannerItems = gql`
  ${PromoBannerItemFragment}

  query GetPromoBannerItems(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PromoBannerItemOrder]
    $where: PromoBannerItemFilter
    $preview: Boolean
  ) {
    promoBannerItemCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...PromoBannerItemFragment
      }
    }
  }
`;

/**
 * Get all PromoBannerItem entries with pagination (full - 2 levels deep)
 */
export const getFullPromoBannerItems = gql`
  ${FullPromoBannerItemFragment}

  query GetFullPromoBannerItems(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [PromoBannerItemOrder]
    $where: PromoBannerItemFilter
    $preview: Boolean
  ) {
    promoBannerItemCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullPromoBannerItemFragment
      }
    }
  }
`;
